export const COLLAPSED_OUTPUT_HEIGHT = 320;

export function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

export function stringValue(value: unknown) {
  return typeof value === "string" ? value : "";
}

export const text = stringValue;

export function displayName(name: string) {
  return name
    .replace(/^(ollama_|tavily_|send_)/, "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function domain(url: string) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function constrainsOutput(name: string) {
  return ![
    "calculate",
    "ollama_web_search",
    "ollama_web_fetch",
    "tavily_web_search",
    "tavily_web_fetch",
    "send_email_notification",
    "send_whatsapp_message",
    "agent_workspace_shell",
    "agent_workspace_command_await",
    "agent_workspace_command_inspect",
    "agent_workspace_command_stdin",
    "agent_workspace_command_stop",
    "agent_workspace_upload_artifact",
    "workspace_list",
    "workspace_read",
    "workspace_edit",
    "workspace_overwrite",
    "workspace_write",
    "workspace_patch",
    "workspace_rg",
    "workspace_glob",
    "proxmox_target_status",
    "proxmox_target_resources",
    "proxmox_inventory",
    "proxmox_target_power",
  ].includes(name);
}

export function formatKey(key: string) {
  return key
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export const titleCase = formatKey;
